function cheat(){

    var synth = false;
    var voices = false;

    var spaceCount = 0;
    var timeThreshold = 1000; 
    var lastKeyPressTime = 0;

    document.addEventListener('keydown', function(event) {

        if (event.code === 'Space') {

            if(!synth){
                synth = window.speechSynthesis;
                voices = getEnglishVoices();
            }

            if(!document.querySelector('.credits-wrap')){
                event.preventDefault();

                var currentTime = new Date().getTime();

                if (currentTime - lastKeyPressTime < timeThreshold) {

                    spaceCount++;

                    if (spaceCount === 3) {
                        document.body.classList.add('cheat');
                    }

                } else {
                    spaceCount = 1; 
                }

                lastKeyPressTime = currentTime;
            }
        }

    });

    
    var gridItems = document.querySelectorAll('.grid-item');

    for (let a = 0; a < gridItems.length; a++) {
        const item = gridItems[a];

        item.addEventListener('mouseenter', function(){
            if(document.body.classList.contains('cheat')){
                var msg = new SpeechSynthesisUtterance();
                voices = getEnglishVoices();
                var rand = Math.floor(Math.random() * voices.length-1);
                msg.voice = voices[rand]; 
                msg.text = item.querySelector('.text').innerHTML;
                synth.speak(msg);
            }
        });

        item.addEventListener('mouseleave', function(){
            if(document.body.classList.contains('cheat')){
                synth.cancel();
            }
        });
        
    }

    // document.addEventListener("mousemove", (e) => {

    //     if(document.body.classList.contains('cheat')){

    //         console.log(e);
    //     }

    // }); 

    function build_synth(){

        if(synth){
            synth.cancel();
        }else{
            synth = window.speechSynthesis;
        }

    }


    // function speakIt(elm){
        
        
    //     let gridItms = document.querySelectorAll(".grid-item");
    //     var randItem = Math.floor(Math.random() * gridItms.length-1);
        
    //     let gridItm = gridItms[randItem];
        
    //     var msg = new SpeechSynthesisUtterance();
        
    //     var voices = getEnglishVoices();
    //     var rand = Math.floor(Math.random() * 20);
    //     msg.voice = voices[rand]; 
        
    //     msg.text = gridItm.querySelector('.text').innerHTML;
    //     synth.speak(msg);

    // }
   
    function getEnglishVoices() {
        // Fetch available voices from the browser
        let voices = synth.getVoices()
      
        // Filter the voices to include only English ones
        let englishVoices = voices.filter(voice => 
          voice.lang.includes('en-GB')
        );
      
        // Sort by name, so you can easily preview them in a more orderly manner
        englishVoices.sort((a, b) => a.name.localeCompare(b.name));
      
        // Log out the list of available English voices
        console.log('Available English Voices:');
        englishVoices.forEach((voice, index) => {
          console.log(`${index + 1}: ${voice.name} (${voice.lang})`);
        });
      
        return englishVoices;
      }

 };
    

export default cheat;



// var hasWindow = typeof window === 'object' && window !== null && window.self === window && window.navigator !== null
//   var bIsiOS = hasWindow && /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream
//   var iOSVoiceNames = [
//     'Maged',
//     'Zuzana',
//     'Sara',
//     'Anna',
//     'Melina',
//     'Karen',
//     'Samantha',
//     'Daniel',
//     'Rishi',
//     'Moira',
//     'Tessa',
//     'Mónica',
//     'Paulina',
//     'Satu',
//     'Amélie',
//     'Thomas',
//     'Carmit',
//     'Lekha',
//     'Mariska',
//     'Damayanti',
//     'Alice',
//     'Kyoko',
//     'Yuna',
//     'Ellen',
//     'Xander',
//     'Nora',
//     'Zosia',
//     'Luciana',
//     'Joana',
//     'Ioana',
//     'Milena',
//     'Laura',
//     'Alva',
//     'Kanya',
//     'Yelda',
//     'Tian-Tian',
//     'Sin-Ji',
//     'Mei-Jia'
//   ];
  
//   if (bIsiOS) {
//     let iOSVoices = []
    
//     for (var i = 0; i < voices.length; ++i) {
//       if (iOSVoiceNames.includes(voices[i].name)){
//         iOSVoices.push(voices[i]);
//       }
//     }
//     voices = iOSVoices;
//   }



 